import { apiGet, apiPost } from '@/lib/api';
/**
 * Authentication Service
 * 处理所有认证相关的API调用
 */
export interface UserInfo {
  id?: string;
  name?: string;
  email?: string;
}
/**
 * 获取用户信息
 */
export async function fetchUserInfo(): Promise<UserInfo> {
  const result = await apiGet<any>('/api/user/info');
  const data = result?.data || result || {};
  return {
    id: data.id || data.userId || '',
    name: data.name || data.displayName || 'User',
    email: data.email || data.mail || '',
  };
}
/**
 * 登出
 */
export async function logout(): Promise<void> {
  await apiPost('/api/logout');
  // Clear local storage
  localStorage.removeItem('user-token');
  localStorage.removeItem('user-info');
  localStorage.removeItem('isLoggedIn');
  // Refresh user info endpoint to clear server session
  await apiGet('/api/user/info');
}
/**
 * 初始化登录状态
 */
export async function initializeLoginState(): Promise<{
  isLoggedIn: boolean;
  userInfo?: UserInfo;
}> {
  const token = localStorage.getItem('user-token');
  const isLoggedInStr = localStorage.getItem('isLoggedIn');
  const userInfoStr = localStorage.getItem('user-info');
  if (!token || isLoggedInStr !== 'true') {
    return { isLoggedIn: false };
  }
  let userInfo: UserInfo | undefined;
  // Try to load user info from localStorage first
  if (userInfoStr) {
    try {
      userInfo = JSON.parse(userInfoStr);
    } catch (error) {
      console.error('Failed to parse stored user info:', error);
    }
  }
  // Always try to fetch fresh user info from API
  try {
    const freshUserInfo = await fetchUserInfo();
    userInfo = freshUserInfo;
    localStorage.setItem('user-info', JSON.stringify(freshUserInfo));
  } catch (error) {
    console.error('Error refreshing user info:', error);
    // Keep existing user info if API call fails
  }
  return {
    isLoggedIn: true,
    userInfo,
  };
}
